document.addEventListener("DOMContentLoaded", function () {
  function picassoUVPInit() {
    if (window.innerWidth < 768) {
      var picassoUVPSlider = document.querySelector(".picasso-uvp__slider");
      var flktypicassoUVP = new Flickity(picassoUVPSlider, {
        wrapAround: true,
        draggable: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        autoPlay: true,
      });
    } else {
      var flktypicassoUVP = Flickity.data(".picasso-uvp__slider");
      if (flktypicassoUVP) {
        flktypicassoUVP.destroy();
      }
    }
  }

  window.addEventListener(
    "resize",
    function (event) {
      picassoUVPInit();
    },
    true
  );

  picassoUVPInit(); // Call the function initially
});
